import { UnitEnum } from '@/api/rest/resources/types/units';
import { GraphFact } from '@/components/Charts/types';
import { Logger } from '@/lib/logs/logger';
import { Area, Dimension } from '@/utils/area';
import { isNullish } from '@/utils/booleans';

export const UNIT_ENUM_DIMENSION_MAP: Partial<Record<UnitEnum, Dimension>> = {
  [UnitEnum.ha]: 'hectares',
  [UnitEnum['km^2']]: 'squareKilometers',
  [UnitEnum['m^2']]: 'squareMeters',
} as const;

export const formatGraphFactToArea = (fact: GraphFact | null): Area | null => {
  if (isNullish(fact)) {
    return null;
  }

  const unit = fact?.unit as UnitEnum | undefined;

  if (isNullish(unit)) {
    Logger.error(`Unit is missing in fact: ${fact}`);
    return null;
  }

  if (isNullish(fact.value) || typeof fact.value !== 'number') {
    return null;
  }

  const factDimension = UNIT_ENUM_DIMENSION_MAP[`${unit}` as UnitEnum];

  if (!factDimension) {
    Logger.error(`Unsupported area unit for ${fact.name} fact: ${unit}`);
    return null;
  }

  return new Area({
    value: fact.value,
    dimension: factDimension,
  });
};
